/* CEJ的每个学员的单元知识掌握情况 */
/* Author: renwanfeng */
/* create:2019/07/10 */
<template>
  <div class="flex-center flex-column mainbody">
    <!--标题 -->
    <div id="header">
      <div class="header-title-word"><span style="fontSize: 20px">{{lang['header-title-word'] | multiReplace([['{name}', Data.u_name]])}}</span></div>
      <div class="bg"><img src="../../../../static/images/PeasonalizedTarget-background.png"></div>
    </div>
    <!--引入语 -->
    <div class="text-border-panel">
      <div class="maintext">
        <p class="flex-row-center orange-bold" v-html="Data.parent_name_l2"> </p>
        <div v-if="Data.type === 'last'">
          <template v-if="level != '-1'">
            <div v-html="getProcessedHtml(lang['text-border-panel'], [['{name}', Data.u_name],['{topic}', Data.topic]])"></div>
            <!-- <div v-html="lang['text-border-panel'] | multiReplace([['{name}', Data.u_name],['{topic}', Data.topic]])"></div> -->
          </template>
          <template v-else>
            <div v-html="getProcessedHtml(lang['text-border-panel-1'], [['{name}', Data.u_name],['{topic}', Data.topic]])"></div>
          </template>
        </div>
        <div v-else-if="Data.type === 'next'">
          <template v-if="level != '-1'">
              <div v-html="getProcessedHtml(lang['next-text-border-panel'], [['{name}', Data.u_name]])"></div>
            </template>
            <template v-else>
              <div v-html="getProcessedHtml(lang['next-text-border-panel-else'], [['{name}', Data.u_name]])"></div>
          </template>
        </div>
        <div v-else>
            <div v-if="level != '-1'">
             <p v-html="getProcessedHtml(lang['orange-bold'], [['{name}', Data.u_name], ['{topic}', Data.topic]])"></p>
            </div>
            <div v-else>
             <p v-html="getProcessedHtml(lang['orange-bold-else'], [['{name}', Data.u_name], ['{topic}', Data.topic]])"></p>
            </div>
        </div>
      <div v-if="Data.tips" style="text-indent: 2px;font-size: 15px" v-html="addDiv(Data.tips)"></div>
      </div>
      <!-- </div>
    <div id="resource"> -->
      <!--单词 key_word-->
      <div class="resource_cartoon" v-if="Data.key_word.length > 0">
        <p>
          <span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['resource-title'] }}:</strong>
          </span>
        </p>
        <div class="word-img-row">
          <div class="word-div" v-for="word in Data.key_word">
            <!-- <a class="word-href" :href="'/resource/word_v2/' + word.id_cipher + tailUrl" :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_WORD","type":"word","id": "${word.id}"}`'> -->
            <a class="word-href" :href="'/resource/word_v2/' + word.id_cipher + tailUrl"
              @click="content_href_learning('word', word.id)">
              <img class="word-img" v-if="level == '-1' && word.word_picture_link_levelk != ''"
                :src="word.word_picture_link_levelk"></img>
              <img class="word-img" v-else-if="word.word_picture_link" :src="word.word_picture_link"></img>
              <img class="word-img" v-else src="http://s.kg.51talkjr.com/85703bb4-c163-45f5-9f60-f208cda0d9d0.jpeg"></img>
              <div class="word-img-div">
                <div class="word-sound-img">
                  <i v-if="word.cej_ph_en" class="word-sound"
                    @click.stop.prevent="sound_custom(word.cej_ph_en, 'word', word.id)"></i>
                </div>
              </div>
              <div class="word-text-div" v-bind:style="{ fontSize: changeFontSize(word.word_name) + 'px' }">
                <span v-if="word.is_wrong == 1" class="orange-bold">{{ word.word_name }}
                </span>
                <span v-else class="blue-bold">{{ word.word_name }}
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!--自然拼读 phonic-->
      <div class="resource_song" v-if="Data.phonic.length > 0">
        <p>
          <span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['resource_song'] }}:</strong>
          </span>
        </p>
        <div class="maintext">
          <div class="p-container" v-for="(item, index) in Data.phonic">
            <p class="p-english family-english size-english">
              <span class="p-order">{{ index + 1 }}.</span>
              <!-- <a :href="'/resource/phonic/' + item.id_cipher + tailUrl" :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_PHONIC","type":"phonic","id":${item.id}}`'> -->
              <a :href="'/resource/phonic/' + item.id_cipher + tailUrl" @click="content_href_learning('phonic', item.id)">
                <span v-if="item.is_wrong == 1" class="orange-bold"> {{ item.phonic_name }}({{ item.phonic_type }}) </span>
                <span v-else class="blue-bold"> {{ item.phonic_name }} ({{ item.phonic_type }}) </span>
              </a>
              <i class="word-sound" @click.stop.prevent="sound_custom(item.media_link, 'phonic', item.id)"></i>
              <!-- <i class="word-sound" @click="sound(item.media_link)" :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_PHONIC_SOUND","type":"phonic","id":${item.id}}`'></i> -->
            </p>
          </div>
        </div>
      </div>
      <!--核心句子 sentence-->
      <div class="resource_book" v-if="Data.sentence.length > 0">
        <p><span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['resource_book'] }}:</strong></span>
        </p>
        <div class="maintext">
          <div class="p-container" v-for="(item, index) in Data.sentence">
            <p class="p-english family-english size-english">
              <span class="p-order">{{ index + 1 }}.</span>
              <a :href="'/resource/sentence/' + item.id_cipher + tailUrl"
                @click="content_href_learning('sentence', item.id)">
                <span v-if='item.is_wrong == 1' class="orange-bold">{{ item.sentence_en }}</span>
                <span v-else class="blue-bold">{{ item.sentence_en }}</span>
              </a>
              <!-- :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_SENTENCE_SOUND","type":"sentence","id": ${item.id}}`' -->
              <i v-if="item.sentence_en_mp3" class="word-sound"
                @click.stop.prevent="sound_custom(item.sentence_en_mp3, 'sentence', item.id)"></i>
            </p>
            <p class="sentence-answer" v-if="item.sentence_en_answer != null">{{ item.sentence_en_answer }}
              <!-- style="color: RGB(27, 70, 125)"  p-chinese family-chinese size-chinese  -->
              <!-- <span v-text="item.sentence_en_answer"></span> -->
              <i v-if="item.sentence_en_answer_mp3" class="word-sound"
                @click.stop.prevent="sound_custom(item.sentence_en_answer_mp3, 'sentence', item.id)"></i>
            </p>
          </div>
        </div>
      </div>
      <!--句型 sentence_structure -->
      <div class="resource_book" v-if="Data.sentence_structure.length > 0">
        <p><span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['sentence_structure'] }}:</strong></span>
        </p>
        <div class="maintext">
          <div class="p-container" v-for="(item, index) in Data.sentence_structure">
            <p class="p-english family-english size-english">
              <span class="p-order">{{ index + 1 }}.</span>
              <span v-if="item.is_wrong == 1" class="orange-bold"> {{ item.sentence_structure }}({{ item.meaning }}) </span>
              <span v-else class="blue-bold"> {{ item.sentence_structure }} ({{ item.meaning }}) </span>
            </p>
          </div>
        </div>
      </div>
      <!--韵律童谣 audio -->
      <div class="resource_book" v-if="Data.audio.length > 0">
        <p><span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['audio'] }}:</strong></span>
        </p>
        <div class="maintext">
          <div class="p-container" v-for="(item, index) in Data.audio">
            <p class="p-english family-english size-english">
              <a :href="'/resource/audio/' + item.id_cipher + tailUrl" @click="content_href_learning('audio', item.id)">
                <span class="blue-bold">
                  <span class="p-order">{{ index + 1 }}.</span> {{ item.title }}({{ item.title_cn }})
                </span>
              </a>
            </p>
          </div>
        </div>
      </div>
      <!--语法 grammar_level-->
      <div class="resource_activity" v-if="Data.grammar_level.length > 0">
        <p>
          <span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>{{ lang['grammar_level'] }}:</strong>
          </span>
        </p>
        <div class="maintext">
          <div class="p-container" v-for="(item, index) in Data.grammar_level">
            <p class="p-english family-english size-english">
              <a :href="'/resource/grammar/' + item.id_cipher + tailUrl"
                @click="content_href_learning('grammar', item.id)">
                <span v-if="item.is_wrong == 1" class="orange-bold">
                  <span class="p-order">{{ index + 1 }}.</span> {{ item.grammar_level_en }}({{ item.grammar_level }})
                </span>
                <span v-else class="blue-bold">
                  <span class="p-order">{{ index + 1 }}.</span> {{ item.grammar_level_en }}({{ item.grammar_level }})
                </span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseVue from '@/components/BaseVue'
import Utils from "@nat/heibao-utils"
require('@/assets/css/peasonalized-target.css')
export default {
  name: 'UnitKnowledgeTemplate',
  extends: BaseVue,
  data() {
    return {
      Data: {
        tips: '',
        u_name: 'Eric',
        url_params: ' ',
        user_id: '',
        unit_id: '',
        type: '', //last,next
        // parent_id_l2: 793101,
        parent_id_l2: 122,
        parent_name_l2: "",
        topic: '',
        unit_index: "",
        level: '',
        audio: [],
        key_word: [
          // {
          //   id: 12082,
          //   word_name: "bag",
          //   word_picture_link: "",
          //   cej_ph_en: "http://s.kg.51talkjr.com/d51486b0-5b02-4f1c-9d74-6769ec23278a.mp3",
          //   uuid: "a68198ad02d87f5a9d8c11984c4a819f",
          //   id_cipher: "DCB23A40944E72371C378A591CD2858E",
          //   is_wrong: 1
          // }
        ],
        phonic: [
          // {
          //   id: 1,
          //   phonic_name: "big A",
          //   phonic_type: "字母",
          //   media_link: "http://s.kg.51talkjr.com/2ff49322-8e97-49e0-858f-f2dadf5ae59a.mp3",
          //   uuid: "ab5ee1d956bc9edff54d6ca4fa85c142",
          //   id_cipher: "04F7AB6F90FEEA80A807394CF1CB2CCD",
          //   is_wrong: 0
          // }
        ],
        sentence: [
          // {
          //   id: 2,
          //   sentence_en: "What's that?",
          //   sentence_en_answer: "It's a pen.",
          //   sentence_en_mp3: "http://s.kg.51talkjr.com/8039396c-77fe-4542-9f50-67234ee66e16.mp3",
          //   sentence_en_answer_mp3: "http://s.kg.51talkjr.com/5b0e5d33-e64d-4687-8179-21bb00613464.mp3",
          //   uuid: "5e4be6ee96ba99fc0545dc945b006637",
          //   id_cipher: "EF148819C0F2A35D9440FF3DBE7AE069",
          //   is_wrong: 0
          // }
        ],
        sentence_structure: [
          // {
          //   id: 140,
          //   sentence_structure: "It's time to...",
          //   meaning: "该做……",
          //   uuid: "f0b0536a1f54b067cd643264730b97c7",
          //   id_cipher: "1879056025FEF40659D6E5743851AC58",
          //   is_wrong: 0
          // }
        ],
        grammar_level: [
          // {
          //   id: 16,
          //   grammar_level_en: "Simple present tense",
          //   grammar_level: "一般现在时",
          //   uuid: "2ec69376772d6b0e7238389f81294bec",
          //   id_cipher: "B2986E9D7F1A0AC2DD385EBFAB0B6CEF",
          //   is_wrong: 0
          // }
        ],
      }
    }
  },
  computed: {
    tailUrl: function () {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function () {
    let user_id = this.$route.query.uid
    let unit_id = this.$route.query.unitid
    let sig = this.$route.query.sig
    let use_sig = this.$route.query.use_sig
    this.user_id = this.$route.query.uid
    this.unit_id = this.$route.query.unitid
    this.level = this.$route.query.level
    if (user_id === undefined || unit_id === undefined) return
    // let realSig = this.generateSig(user_id + unit_id)
    // if (!this.checkSig(user_id + unit_id, sig)) return
    // 支持调试和前端上线的sig验证模式
    await this.getLang();
    document.title = this.lang.UnitKnowledgeTemplateTitle
    let lang = Utils.getQuery('metalang') || localStorage.getItem('currLang');
    if (use_sig != undefined) {
      var url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_unit_mastery?uid=' + user_id + '&unitid=' + unit_id + '&use_sig=0'
    } else {
      var url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_unit_mastery?uid=' + user_id + '&unitid=' + unit_id + '&sig=' + sig
    }
    url = `${url}&appkey=magic&timestamp=${new Date().getTime()}&metalang=${lang}`
    this.url_params = this.$route.fullPath.split('?')[1]
    this.type = this.$route.query.type
    let that = this;
    // 增加单元知识点掌握报告埋点
    pindData.add_params({ "t": "ukm.000001" });
    let value = '{"t":"ukm.000001","v":{"action":"PG_UNIT_KNOWLEDGE_MASTERY","userid":' + this.user_id + ',"unitid":' + unit_id + '}}';
    __sdonclick(value);
    console.log('currLang====', this.currLang)
    // 因为这部分接口正常代码是10000,错误是0；和django自带的0是正常不一致，因此单独写个获取函数，同时捕获异常
    $.ajax({
      type: "GET",
      url: url,
      timeout: this.TIMEOUT,
      success: function (data) {
        if (typeof (data) === 'string') data = JSON.parse(data)
        if (data.error_code == 10000) {
          that.Data = data.ret.data
          that.Data.topic = data.ret.data.parent_name_l2.split(' ')[1]  //取出单元主题中文
          that.Data.tips = ''
          that.Data.type = that.type
          console.log('that url type:' + that.Data.type)
        } else {
          that.Data.tips = that.getProcessedHtml(that.lang.data_tips, [['{name}', that.Data.u_name]])
          that.Data.u_name = 'Student'
          console.log('Response Error data: ' + data)
        }
      }
    })
  },
  methods: {
    getProcessedHtml(value, params) {
      let processedString = this.$options.filters.multiReplace(value, params);
      return processedString;
    },
    changeFontSize: function (word_name) {
      //9*15 = word_name.length * X
      if (word_name.length > 9) return parseInt(9 * 15 / word_name.length)
    },
    sound: function (url) {
      var audio = new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    },
    sound_custom: function (url, type, id) {
      var audio = new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
      //点击单元知识掌握报告页面某个知识的发音（目前只有单词、自然拼读和句子)
      let action = "CK_UNIT_KNOWLEDGE_MASTERY_" + type.toLocaleUpperCase() + '_SOUND'
      pindData.pind_send({ "action": action, "type": type, "id": id, "userid": this.user_id, 'unitid': this.unit_id });
    },
    content_href_learning: function (type, id) {
      //点击单元知识掌握报告中的超链子页面学习（单词、自然拼读、句子）
      let action = "CK_UNIT_KNOWLEDGE_MASTERY_" + type.toLocaleUpperCase()
      pindData.pind_send({ "action": action, "type": type, "id": id, "userid": this.user_id, 'unitid': this.unit_id });
    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/template/target/UnitKnowledgeMastery.vue